import { socialApi } from './shared';

/** Hand-authored LinkedIn endpoint copy and examples. */
export const LINKEDIN = socialApi({
  id: 'linkedin',
  name: 'LinkedIn',
  blurb:
    'Public LinkedIn member and company pages as clean, normalized JSON: pass a profile or company URL, get a structured payload back. One key, one wallet, billed per request in real dollars.',
  endpoints: {
    profile: {
      description: 'Full public profile for a LinkedIn member by URL: name, headline, location, followers, about, work experience, education, skills, certifications and languages.',
      input: { url: 'https://www.linkedin.com/in/williamhgates' },
      sample: {
        firstName: 'Bill',
        lastName: 'Gates',
        location: 'Seattle, Washington, United States',
        followerCount: 36_400_000,
        about: 'Chair of the Gates Foundation. Founder of Breakthrough Energy. Co-founder of Microsoft.',
        photo: 'https://media.licdn.com/dms/image/williamhgates.jpg',
      },
    },
    company: {
      description: 'A LinkedIn company page by URL: name, description, employee count, industry, website and logo.',
      input: { url: 'https://www.linkedin.com/company/microsoft' },
      sample: {
        name: 'Microsoft',
        description: 'Every person and organization on the planet to achieve more.',
        employeeCount: 238_000,
        industry: 'Software Development',
        website: 'https://news.microsoft.com/',
        tagline: 'We empower the world to achieve more.',
        logoUrl: 'https://media.licdn.com/dms/image/microsoft-logo.png',
      },
    },
    company_posts: {
      description: 'List a company page’s recent posts by URL: text, link and publish date.',
      input: { url: 'https://www.linkedin.com/company/microsoft', limit: 10 },
      sample: {
        items: [
          {
            id: '7429579034096726016',
            url: 'https://www.linkedin.com/posts/microsoft-activity-7429579034096726016',
            text: 'Today we’re introducing new Copilot features that help teams ship faster.',
            publishedAt: '2026-02-17T17:34:36.617Z',
          },
        ],
      },
    },
    post: {
      description: 'A single LinkedIn post or article by URL: title, text, author, like and comment counts, and publish date.',
      input: { url: 'https://www.linkedin.com/posts/williamhgates_activity-7000000000000000000-abcd' },
      sample: {
        url: 'https://www.linkedin.com/posts/williamhgates_activity-7000000000000000000-abcd',
        title: 'Being a Father Has Made me a Better Leader',
        text: 'A few reflections on leadership and family from the past year…',
        author: 'Bill Gates',
        likes: 210,
        comments: 17,
        createdUtc: 1_750_516_559,
      },
    },
    search_posts: {
      action: 'Post search',
      description: 'Search public LinkedIn posts by keyword with cursor pagination: text, link and publish date. Results come from search-engine matches and work best with English keywords.',
      input: { query: 'ai agents' },
      sample: {
        posts: [
          {
            url: 'https://www.linkedin.com/posts/aagupta_ai-agents-activity-7354600338621906944-RvXR',
            text: 'Here’s a simple guide to the 4 categories of AI agents you should know…',
            publishedAt: '2025-07-25T19:56:02.566Z',
          },
        ],
      },
    },
  },
});
